import type { SVGProps } from 'react'
const SvgWhatsappLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 4a10 10 0 0 0-8.17 15.75l-1.79 3.91a.2.2 0 0 0 .05.24.24.24 0 0 0 .24.07L8.6 22.4a9.9 9.9 0 0 0 5.39 1.6h.03a10 10 0 1 0-.03-20Zm5.56 13.84a4 4 0 0 1-.96 1.22l-.13.1c-.04.05-.06.05-.1.07a1.6 1.6 0 0 1-.88.33h-.1c-.23-.01-.45-.06-.66-.16l-.78-.32-.07-.04-.71-.35-.09-.07-.67-.39-.05-.04a14.3 14.3 0 0 1-3.84-3.48l-.3-.39-.14-.2-.13-.2-.24-.36-.02-.02c-.06-.13-.15-.24-.21-.37a12 12 0 0 1-.9-1.89c-.23-.65-.3-1.07-.04-1.52.22-.3.5-.57.8-.78.5-.37.72-.5.94-.55.19-.03.38-.01.56.05.1.03.19.07.26.13.42.26 1.37 1.5 1.68 2.08.18.28.25.61.2.94-.07.26-.22.4-.66.73-.09.1-.2.16-.26.22l-.04.05-.02.02a.46.46 0 0 0-.07.26c.05.4.19.78.41 1.1a5.1 5.1 0 0 0 2 1.79c.46.22.74.28.9.22.01-.03.06-.03.08-.05l.28-.32c.13-.2.3-.37.5-.48l.15-.07a1.09 1.09 0 0 1 .94.09 9.7 9.7 0 0 1 2.24 1.6c.13.16.21.36.21.57.01.17-.02.33-.08.48"
    />
  </svg>
)
export default SvgWhatsappLogo
